import {
  Component,
  Input,
  forwardRef,
  ViewChild,
  ElementRef,
  Renderer2,
  Injector,
  OnInit
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  NgControl
} from '@angular/forms';

export const INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputComponent),
  multi: true
};

const noop = () => { };

@Component({
  selector: 'db-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [INPUT_CONTROL_VALUE_ACCESSOR]
})

export class InputComponent implements ControlValueAccessor, OnInit {

  value: string;

  ngControl: NgControl;

  @Input() type = 'text';
  @Input() id: string;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() readonly: boolean;

  @ViewChild('inputElement', { static: true }) private _inputElement: ElementRef;
  get inputElement(): ElementRef {
    return this._inputElement;
  }

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  constructor(
    private _renderer: Renderer2,
    private injector: Injector
  ) { }

  ngOnInit() {
    // Get NgControl instance via Injector
    // for validation
    this.ngControl = this.injector.get(NgControl);

    if (!this.id) {
      this.id = 'text-input-' + this.label;
    }
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  // From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this._renderer.setProperty(this._inputElement.nativeElement, 'disabled', isDisabled);
  }

  onChange(event: any) {
    this.onChangeCallback(event.target.value);
  }

  onKeyup(event: any) {
    this.onChangeCallback(event.target.value);
  }

  onBlur(event: any) {
    this.onTouchedCallback();
  }
}
